import { Widget } from "fmko-ts-common";
import CertTestAdminApp from "./CertTestAdminApp";
import CertTestService from "./CertTestService";

export default class TestGroupWidget extends Widget {
    constructor(name: string) {
        super();

        let checkbox = <HTMLInputElement>document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.className = "checkbox-inline";
        checkbox.checked = false;

        let testList = <HTMLParagraphElement>document.createElement("p");
        testList.innerText = "";

        testList.classList.add("hidden");

        checkbox.addEventListener("click", (ev: MouseEvent) => {
            if (checkbox.checked) {
                if (CertTestAdminApp.certTestPanel.selectedWhitelisting) {
                    CertTestService.getInstance().getCertTestGroup(name,
                        CertTestAdminApp.certTestPanel.selectedWhitelisting).then((group) => {
                        while (testList.firstChild) {
                            testList.removeChild(testList.firstChild);
                        }
                        for (let test of group.testCases) {
                            testList.appendChild(document.createElement(`br`));
                            testList.appendChild(document.createTextNode(test.title));
                        }
                    }).catch(err => CertTestAdminApp.alert("Hent fejlede", err.message));
                    testList.classList.remove("hidden");
                }
            } else {
                testList.classList.add("hidden");
            }
        });

        let div = <HTMLDivElement>document.createElement("div");
        div.appendChild(checkbox);
        div.appendChild(testList);
        this.element = div;
    }
}
